<div *ngIf="displayMode === 'chips'" class="location-chips" role="group" aria-label="Locations">
    <span class="location-chips-title">Locations:</span>
    <div class="location-chips-options">
        <button type="button" class="loc-btn" [class.active]="allLocationsSelected" [attr.aria-pressed]="allLocationsSelected" [disabled]="locations.length === 0" (click)="selectAllLocations()">All</button>
        <button *ngFor="let location of locations" type="button" class="loc-btn" [class.active]="location.checked" [attr.aria-pressed]="location.checked" (click)="location.checked = !location.checked; onLocationsChanged()">{{ location.location.name }}</button>
        <span *ngIf="locations.length === 0" class="location-chips-empty">No locations available</span>
    </div>
</div>
<ng-container *ngIf="displayMode === 'checkbox'">
<div *ngIf="locations.length > 1" style="font-size: 16px;">Locations: </div>
<div *ngIf="locations.length > 1" class="d-flex pl-1 align-items-center flex-wrap" style="font-size: .8rem; line-height: 1rem;">
    <div *ngFor="let location of locations" class="ms-2">
        <input [(ngModel)]="location.checked" (ngModelChange)="onLocationsChanged()" type="checkbox" name="{{location.location.name}}"/> {{location.location.name}}
    </div>
</div>

</ng-container>
